import React from "react";
import { Link } from "react-router-dom";

export const TakeoverLinks = () => {
  return (
    <nav className="relative flex min-h-screen w-full flex-col items-center justify-center bg-cream py-6 md:py-12">
      <h1 className="mb-10 md:mb-20 font-cormorant text-2xl md:text-4xl font-light text-cocoa">
        Nos Collections
      </h1>

      <div className="flex flex-col items-center space-y-8 md:space-y-16 px-4 md:px-8 w-full">
        {LINKS.map((link) => (
          <Link
            key={link.id}
            to={link.href}
            className="group relative overflow-hidden w-full max-w-[300px] sm:max-w-[500px] md:max-w-[800px] rounded-full"
          >
            <div className="absolute inset-0 bg-[#333333] opacity-0 transition-opacity duration-300 group-hover:opacity-100 rounded-full" />
            <span className="flex justify-center items-center py-4 md:py-8 text-3xl sm:text-4xl md:text-6xl lg:text-8xl font-thin uppercase text-cocoa transition-all duration-500 group-hover:text-cream relative z-10">
              {link.text}
            </span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

const LINKS = [
  {
    href: "/categories/mobilier/habitat",
    text: "Habitat",
    id: 1,
  },
  {
    href: "/categories/mobilier/professionnel",
    text: "Professionnel",
    id: 2,
  },
  {
    href: "/categories/mobilier/exterieur",
    text: "Exterieur",
    id: 3,
  }
];

export default TakeoverLinks;